import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { config, externalPaths } from "@config";
import { TranslationService } from "@core-services/translation.service";
import { CoreModule } from "@modules/core/core.module";

@Component({
	selector: "tax-info-box-ui",
	standalone: true,
	imports: [CoreModule],
	templateUrl: "./tax-info-box.component.html",
	styleUrl: "./tax-info-box.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class TaxInfoBoxUIComponent implements OnInit {
	@Input() showLink: boolean;
	@Input() showWarning = false;
	@Input() text1 = "";
	@Input() text2 = "";
	@Input() linkLabel = "";

	link = "";

	ngOnInit(): void {
		const language: string = TranslationService.getLanguageIsoCode() === "de" ? "de" : "en-us";
		this.link = `${config.helpcenterUrl}hc/${language}/articles/${externalPaths.taxes.hdLink}`;
	}
}
